const ITEMS = [
  "Pure Silk",
  "Katia Silk",
  "Raw Silk",
  "Mulberry Silk",
  "Ghiccha Silk",
  "Tussar Silk",
  "Matka",
  "Dupion",
  "Linen",
  "Cotton",
  "Viscose",
  "Raffia",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-xl italic text-slate-300 sm:text-2xl">{item}</span>
        <span className="text-sm text-gold">✦</span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div data-testid="fabric-marquee" className="overflow-hidden border-y border-gold/25 bg-navy py-5">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
